import axiosNest from '../../api/axiosNest';

/**
 * Ręczne łączenie zlecenia z TMS z prezleceniem (15.10.2026, pętla zwrotna
 * z TMS). Odpowiada `apps/api/src/via/pre-order-link.controller.ts`; trasy
 * są za przełącznikiem `preOrderTmsManualLink` (bez niego API odpowiada 404).
 */

/** Klucz przełącznika — ten sam co w rejestrze API. */
export const FEATURE_PRE_ORDER_TMS_LINK = 'preOrderTmsManualLink';

/** Najkrótszy powód — lustro `MIN_LINK_REASON_LENGTH` z API. */
export const MIN_LINK_REASON_LENGTH = 10;

export interface PreOrderLinkCandidate {
  userOfferId: number;
  orderNumber: string | null;
  viaWriteStatus: string | null;
  sentToVia: boolean;
  fromDate: string;
  toDate: string;
  fromCity: string | null;
  toCity: string | null;
  fromCountry: string | null;
  toCountry: string | null;
}

export interface PreOrderLinkState {
  id: number;
  externalId: string | null;
  /** Dlaczego tego wiersza z TMS nie da się połączyć; `null` = da się. */
  refusal: string | null;
  candidates: PreOrderLinkCandidate[];
}

const path = (id: number | string) => `/user-offers/${id}/pre-order-link`;

export async function fetchPreOrderLink(id: number | string): Promise<PreOrderLinkState> {
  const { data } = await axiosNest.get(path(id));
  return data as PreOrderLinkState;
}

/** Połączenie — wiersz z listy albo nasz numer (MAR/…), z powodem. */
export async function linkPreOrder(
  id: number | string,
  target: { preOrderRowId: number } | { orderNumber: string },
  reason: string,
): Promise<{ id: number; externalId: string | null; mergedId: number }> {
  const { data } = await axiosNest.post(path(id), { ...target, reason: reason.trim() });
  return data;
}
